// YASMINA — data & content
// Añade aquí teléfono/WhatsApp cuando los tengas y vuelve a activar los botones.

export const site = {
  name: "Yasmina",
  tagline: "Restaurante de Cocina Árabe y Marroquí en Puigcerdà",
  address: "Plaça del Reg, 1 · 17520 Puigcerdà, Girona",
  addressShort: "Plaça del Reg, 1 · Puigcerdà",
  email: "restaurantecocinaarabeyasmina@gmail.com",
  hours: [
    { day: "Lun — Vie", time: "6:00 – 2:30" },
    { day: "Sáb — Dom", time: "6:00 – 2:30" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=Pla%C3%A7a+del+Reg+1+Puigcerd%C3%A0&output=embed",
  mapLink:
    "https://www.google.com/maps/dir/?api=1&destination=Pla%C3%A7a+del+Reg+1%2C+Puigcerd%C3%A0",
};


// Assets (real fotos del cliente)
const IMG = {
  realTagine:
    "/img/tagine.png",
  realCuscus:
    "/img/cuscus.png",
};

export const images = {
  ...IMG,
  heroTagine:
    "https://images.unsplash.com/photo-1547573854-74d2a71d0826?auto=format&fit=crop&w=2000&q=85",
  spicesBand: "/img/g2.webp",
  teaMint:
    "/img/atay1.webp",
  briwats:
    "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1400&q=85",
  harira:
    "https://images.unsplash.com/photo-1547424450-4b6c8b1c7d0f?auto=format&fit=crop&w=1400&q=85",
  saladMoroc:
    "https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?auto=format&fit=crop&w=1400&q=85",
  zaalouk:
    "https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&w=1400&q=85",
  cuscusRoyal:
    "https://images.unsplash.com/photo-1596797038530-2c107229654b?auto=format&fit=crop&w=1400&q=85",
  cuscusVeg:
    "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=1400&q=85",
  tagineChicken:
    "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1400&q=85",
  tagineVeg:
    "https://images.unsplash.com/photo-1512058454905-6b841e7ad132?auto=format&fit=crop&w=1400&q=85",
  baklava:
    "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=1400&q=85",
  moroccanSweets:
    "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=1400&q=85",
  interior:
    "/img/g6.webp",
  interior2:
    "/img/g9.webp",
  interiorBar:
    "/img/g6.webp",
  sharingTable:
    "/img/g9.webp",
};

// Featured essence tiles (home)
export const essence = [
  {
    name: "Tagine de Cordero",
    kicker: "Fuego lento · 3 h",
    desc:
      "Cordero cocinado lentamente con ciruelas, almendras y especias ras el hanout. Servido en su tagine de barro original.",
    img: IMG.realTagine,
    alt: "Tagine de cordero humeante en restaurante marroquí Yasmina Puigcerdà",
  },
  {
    name: "Cuscús Tradicional",
    kicker: "Al vapor · Sémola trabajada a mano",
    desc:
      "Sémola al vapor con verduras de temporada, garbanzos y caldo especiado. El plato que une a las familias en Marruecos.",
    img: IMG.realCuscus,
    alt: "Cuscús tradicional con verduras de temporada en Yasmina La Cerdanya",
  },
  {
    name: "Harira",
    kicker: "Sopa tradicional · Especiada",
    desc:
      "Tomate, lentejas, garbanzos y cordero en una sopa reconfortante y especiada. La que abre el apetito en cualquier comida.",
    img: "https://images.unsplash.com/photo-1547424450-4b6c8b1c7d0f?auto=format&fit=crop&w=1400&q=85",
    alt: "Harira, sopa tradicional árabe y marroquí en Yasmina Puigcerdà",
  },
  {
    name: "Té Moruno",
    kicker: "Menta fresca · Servido en altura",
    desc:
      "Té verde con menta fresca y hierbabuena, servido en altura como manda la tradición. El broche de oro de cada comida.",
    img: "/img/atay1.webp",
    alt: "Té moruno (Atay) servido en altura en Yasmina Puigcerdà",
  },
];

export const menu = [
  {
    cat: "Tagines",
    items: [
      {
        name: "Tagine de Cordero con Ciruelas y Almendras",
        desc:
          "Cordero cocinado lentamente con ciruelas pasas, almendras tostadas y un toque de canela. Servido en su tagine de barro.",
        img: IMG.realTagine,
      },
      {
        name: "Tagine de Pollo al Limón Confitado",
        desc:
          "Pollo tierno con limones confitados y aceitunas verdes. Un clásico de la cocina de Fez.",
        img: "https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1400&q=85",
      },
      {
        name: "Tagine de Verduras de Temporada",
        desc:
          "La opción vegetal: berenjenas, calabacín, garbanzos y especias ras el hanout. Sabor pleno sin carne.",
        img: "https://images.unsplash.com/photo-1512058454905-6b841e7ad132?auto=format&fit=crop&w=1400&q=85",
      },
    ],
  },
  {
    cat: "Cuscús",
    items: [
      {
        name: "Cuscús Real (Cuscús Royal)",
        desc:
          "Sémola al vapor con cordero, pollo, merguez y un caldo especiado con siete verduras. El plato para compartir por excelencia.",
        img: IMG.realCuscus,
      },
      {
        name: "Cuscús de Verduras",
        desc:
          "Garbanzos, zanahorias, nabo, calabaza y caldo vegetal especiado. Reconfortante y generoso.",
        img: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?auto=format&fit=crop&w=1400&q=85",
      },
    ],
  },
  {
    cat: "Entrantes y para compartir",
    items: [
      {
        name: "Briwats de Carne",
        desc:
          "Triángulos de masa filo rellenos de carne picada especiada con cebolla y hierbas.",
        img: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1400&q=85",
      },
      {
        name: "Harira",
        desc:
          "Sopa tradicional de tomate, lentejas, garbanzos y cordero. Reconfortante, especiada, perfecta para empezar.",
        img: "https://images.unsplash.com/photo-1547424450-4b6c8b1c7d0f?auto=format&fit=crop&w=1400&q=85",
      },
      {
        name: "Ensalada Marroquí",
        desc:
          "Tomate, pepino, cebolla, aceitunas y hierbas frescas con aceite de oliva y limón.",
        img: "https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?auto=format&fit=crop&w=1400&q=85",
      },
      {
        name: "Zaalouk",
        desc:
          "Puré de berenjenas asadas con tomate, ajo y especias. Se come con pan recién hecho.",
        img: "https://images.unsplash.com/photo-1512058564366-18510be2db19?auto=format&fit=crop&w=1400&q=85",
      },
    ],
  },
  {
    cat: "Té y Postres",
    items: [
      {
        name: "Té Moruno con Menta Fresca",
        desc:
          "Té verde con hierbabuena servido en altura, como manda la tradición.",
        img: "/img/atay2.webp",
      },
      {
        name: "Pastelitos Marroquíes",
        desc:
          "Selección de dulces de almendra, miel y agua de azahar. Cuernos de gacela, ghriba y fekkas.",
        img: "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=1400&q=85",
      },
      {
        name: "Baklava",
        desc: "Capas de masa filo con frutos secos y miel perfumada.",
        img: "https://images.unsplash.com/photo-1587314168485-3236d6710814?auto=format&fit=crop&w=1400&q=85",
      },
    ],
  },
];
